import { useNavigate } from 'react-router-dom';
import { useActivation } from '@context/MobileOne';
import { Feedback, ScrollToTop } from '@core/index';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { appButtonType, appRoute } from '@utils/globalConstant';

export const OverviewError = () => {
  // Context
  const navigate = useNavigate();
  const { clearActivationStates, overviewError } = useActivation();

  // Const
  const headerContent = tA11y('ek_reg_api_err_hdl2');
  const copyTextContent = tA11y('ek_reg_api_err_txt1');
  const buttonContent = tA11y('ek_reg_api_err_btn1');

  return (
    <>
      <ScrollToTop>
        <Feedback
          icon='ANGRY'
          headingContent={headerContent}
          copyTextContent={copyTextContent}
          buttonContent={buttonContent}
          buttonType={appButtonType.PRIMARY}
          buttonClick={() => {
            clearActivationStates();
            navigate(appRoute.HOME_PAGE);
          }}
          showCard
          apiError={overviewError}
        />
      </ScrollToTop>
    </>
  );
};

export default OverviewError;
